function lazyComLoading (path) {
  return () => import(`@/components/${path}`)
}
function lazyViemLoading (path) {
  return () => import(`~/${path}`)
}

const Daily = lazyViemLoading('ownerCenter/daily');
const Weekly = lazyViemLoading('ownerCenter/weekly');
const OwnerCenter = lazyViemLoading('ownerCenter/owner-center')
const Enter = lazyViemLoading('sign/enter')
const Account = lazyViemLoading('ownerCenter/account')
const Personal = lazyViemLoading('ownerCenter/personal')
const Work = lazyViemLoading('ownerCenter/work')
const PersonDoc = lazyViemLoading('ownerCenter/person-doc')
const notify = lazyViemLoading('ownerCenter/notify')
const Home = lazyViemLoading('sign/layout')
const SignForm = lazyViemLoading('sign/signform')
const Signup = lazyViemLoading('sign/signup')
const Signin = lazyViemLoading('sign/signin')
const Forget = lazyViemLoading('sign/forget')
const Success = lazyViemLoading('sign/success')
const Layout = lazyViemLoading('sign/layout')

const routes = [
  {
    path: '/',
    redirect: '/Layout'
  },
  {
    path: '/test',
    name: 'test',
    component: lazyViemLoading('test01')
  },
  {
    path: '/enter',
    name: 'enter',
    component: Enter
  },
  {
    path: '/owner',
    redirect: '/owner/account',
    // name: 'owner',
    component: OwnerCenter,
    children:[
      {
        path:'account',
        name:'account',
        component: lazyViemLoading('ownerCenter/account'),
        meta: {
          title:'账户信息'
        }
      },
      {
        path:'personal',
        name:'personal',
        component: lazyViemLoading('ownerCenter/personal'),
        meta: {
          title:'任职信息'
        }
      },
      {
        path:'daily',
        name:'daily',
        component: Daily,
        meta: {
          title:'我的日报'
        }
      },
      {
        path:'weekly',
        name:'weekly',
        component: Weekly,
        meta: {
          title:'我的周报'
        }
      },
      {
        path:'work',
        name:'work',
        component: Work,
        meta: {
          title:'工作目标'
        }
      },
      {
        path:'person/doc',
        name:'personDoc',
        component: PersonDoc,
        meta: {
          title:'个人档案'
        }
      },
      {
        path:'notify',
        name:'notify',
        component: notify,
        meta: {
          title:'通知'
        }
      }
    ]
  },
  {
    path: '/layout',
    // name: 'home',
    component: Layout,
    children: [
      {
        path: '/',
        redirect: '/layout/sign/signin'
      },
      {
        path: '/layout/sign',
        component: SignForm,
        children: [,
          {
            path: '/',
            redirect: '/layout/sign/signin'
          },
          {
            path: '/layout/sign/signin',
            name: 'layout',
            component: lazyViemLoading('sign/signin'),
            meta: {
              title:'登录'
            }
          },
          {
            path: '/layout/sign/forget',
            name: 'layout.sign.forget',
            component: lazyViemLoading('sign/forget'),
            meta: {
              title:'重置密码'
            }
          },{
            path: '/layout/sign/resetPassword',
            name: 'layout.sign.resetPassword',
            component: lazyViemLoading('sign/resetPassword'),
            meta: {
              title:'密码重置'
            }
          },{
            path: '/layout/sign/emailVerification',
            name: 'layout.sign.emailVerification',
            component: lazyViemLoading('sign/emailVerification'),
            meta: {
              title:' 邮箱验证'
            }
          },
        ]
      },
    ]
  },
  {
    path: '/home',
    // name: 'layout',
    component: Home,
    children: [
      {
        path: '/',
        redirect: '/home/sign/signin'
      },
      {
        path: '/home/sign',
        // name: 'layout.sign',
        component: SignForm,
        children: [,
          {
            path: '/',
            name: 'home.sign.signin',
            redirect: '/home/sign/signin'
          },
          {
            path: '/home/sign/signup',
            name: 'home.sign.signup',
            component: lazyViemLoading('sign/signup'),
            meta: {
              title:'注册'
            }
          },
          {
            path: '/home/sign/signin',
            name: 'home',
            component: lazyViemLoading('sign/signin'),
            meta: {
              title:'登录'
            }
          },
          {
            path: '/home/sign/forget',
            name: 'home.sign.forget',
            component: lazyViemLoading('sign/forget'),
            meta: {
              title:'重置密码'
            }
          },
        ]
      },
      {
        path: '/home/success',
        name: 'home.success',
        component: lazyViemLoading('sign/success'),
        meta: {
          title:'注册成功'
        }
      },
    ]
  },
  {path: '*', redirect: '/errorPage/404'},
  {
    path: '/errorPage',
    name: 'errorPage',
    redirect: '/errorPage/404',
    component: lazyViemLoading('errorPage'),
    children: [
      {
        path: '404',
        name: '404',
        component: lazyViemLoading('errorPage/404'),
        meta: {
          title: '404'
        }
      }
    ]
  },
]

export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js